import { cn } from "@/lib/cn";

import { Appear } from "@/components/landing/Appear";
import { RevealGroup, RevealText } from "@/components/landing/RevealText";
import { RollingNumber } from "@/components/landing/RollingNumber";

const COLUMNS = [
  { label: "Если бот заработал", value: "$100", tone: "ink" },
  { label: "Комиссия Spider (30%)", value: "$30", tone: "muted" },
  { label: "Остаётся у вас", value: "$70", tone: "accent" },
] as const;

const TONE_CLASS = {
  ink: "text-landing-ink",
  muted: "text-[#a5a5a5]",
  accent: "landing-gradient-text",
};

export const PricingSection = () => (
  <section
    id="pricing"
    className="border-landing-line scroll-mt-[5.625rem] border-b"
  >
    <RevealGroup className="landing-container flex flex-col items-center pt-[6.25rem] pb-[7.5rem] text-center max-md:py-20">
      <RevealText
        as="h2"
        className="text-landing-ink text-[2rem] leading-[1.2] font-semibold max-md:text-[1.5rem]"
      >
        Мы зарабатываем только тогда, <br className="max-md:hidden" />
        когда зарабатываете вы
      </RevealText>
      <RevealText
        as="p"
        delay={70}
        className="text-landing-ink/70 mt-4 text-[1rem] leading-[1.4] font-semibold"
      >
        Без фиксированной подписки. Spider берёт 30% только с прибыли,{" "}
        <br className="max-md:hidden" />
        которую приносит бот.
      </RevealText>

      <Appear // На мобильном рамка и кружки уходят: колонки становятся строками,
        // разделённые тонкой линейкой, сумма встаёт над подписью
        className="mt-12 flex h-[11.5625rem] w-full items-center gap-4 rounded-2xl border border-[#dcdcdc] bg-white px-10 max-md:mt-8 max-md:h-auto max-md:flex-col max-md:items-stretch max-md:gap-0 max-md:rounded-none max-md:border-0 max-md:px-0 max-md:text-left"
      >
        {COLUMNS.map((col, index) => (
          <div
            key={col.label}
            className="contents"
          >
            {index > 0 && (
              <div
                aria-hidden
                className="size-6 shrink-0 rounded-full border border-[#dcdcdc] max-md:my-4 max-md:h-px max-md:w-full max-md:rounded-none max-md:border-0 max-md:bg-[#e6e6e6]"
              />
            )}
            <div className="flex flex-1 basis-0 flex-col items-center gap-4 max-md:flex-none max-md:basis-auto max-md:items-start max-md:gap-3">
              <span className="text-[0.875rem] leading-none font-medium whitespace-nowrap text-[#666666] max-md:order-2">
                {col.label}
              </span>
              <RollingNumber
                value={col.value}
                className={cn(
                  "text-[3.5rem] leading-none font-medium tracking-[-0.03em] whitespace-nowrap max-md:order-1 max-md:text-[6rem] max-md:tracking-[-0.05em]",
                  TONE_CLASS[col.tone]
                )}
              />
            </div>
          </div>
        ))}
      </Appear>

      <Appear
        as="p"
        className="text-landing-ink/45 mt-12 text-[1rem] leading-[1.4] font-semibold max-md:hidden"
      >
        Без прибыли комиссия не берётся.
      </Appear>
    </RevealGroup>
  </section>
);
